export const styles = {
  mainContainer: "relative flex flex-col w-full",
  secondContainer: "flex w-full min-h-screen bg-left bg-cover bg-profile",
  sideNavContainer:
    "sticky top-0 hidden w-3/12 bg-gradient-to-tr from-blue-800 to-purple-500 md:block",

  //alert
  alertTitle: "text-lg font-medium text-blue-700 dark:text-blue-800",
  alertCaption: "mt-2 mb-4 text-sm text-blue-700 dark:text-blue-800",
  alertLogoutBtn:
    "mr-2 inline-flex items-center rounded-lg bg-blue-700 px-3 py-1.5 text-center text-xs font-medium text-white hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-800 dark:hover:bg-blue-900",
  alertLaterBtn:
    "rounded-lg border border-blue-700 bg-transparent px-3 py-1.5 text-center text-xs font-medium text-blue-700 hover:bg-blue-800 hover:text-white focus:ring-4 focus:ring-blue-300 dark:border-blue-800 dark:text-blue-800 dark:hover:text-white",

  //profile form
  profileForm: "mb-8 space-y-4 md:w-1/3 md:mb-0",
  input: "border border-gray-400 rounded-lg",
  usernameInput: "italic bg-blue-100 border border-gray-400 rounded-lg",
  saveBtn: "px-6 py-1.5 text-white bg-blue-500 rounded-lg hover:bg-blue-600",

  //password form
  updatePwForm:
    "px-6 py-1.5 text-white bg-purple-500 rounded-lg md:my-6 hover:bg-purple-700",
  updatePwBtn:
    "px-6 py-1.5 text-white bg-purple-500 rounded-lg hover:bg-purple-600",
};
